import { useEffect, useState } from 'react';
import { useStore } from 'react-redux';

import { requestStream } from '@swf/core/api/requestStream';
import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

export interface AnnouncementResponse {
  content: string;
  created: Date;
  flags: number;
  fullName: string;
  id: number;
  pinnedPos: number;
  roleFlags: number;
  userId: string;
}

interface Message {
  userId: string;
  created: Date;
  content: string;
}

interface Props {
  clubId: string | number;
}

const useAnnouncementStream = ({ clubId }: Props) => {
  const [state, setState] = useState<Message | null>(null);
  const { getState } = useStore<RootState>();
  const options = select.site.getRequestOptions(getState());

  useEffect(() => {
    const sub = requestStream({
      service: '/api/v1-preview/stream/homegames/announcement',
      body: { clubId },
      ...options
    }).subscribe({
      next: ({ data }) => {
        const { content, created, userId } = data as AnnouncementResponse;

        if (content) {
          setState({ content, created, userId });
        }
      }
    });

    return () => {
      sub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clubId]);

  return { state };
};

export default useAnnouncementStream;
